(function () {
  "use strict";
  window.__BRAND__ = {
    name: "Velodynn",
    fullName: "Velo Dynamics",
    tagline: "Performance meets exclusivity.",
    coords: "42°18′14″ N · 1°55′20″ E",
    email: "info@velodynn.com",
    instagram: { handle: "@velodynn", url: "https://instagram.com/velodynn" },
    nav: [
      { label: "Historia", href: "#historia" },
      { label: "El maillot", href: "#maillot" },
      { label: "Contacto", href: "#reserva" }
    ],
    pillars: [
      {
        title: "Tejido técnico",
        body: "Malla de compresión ligera, costuras planas y zonas de ventilación específicas para puertos largos y calor de verano."
      },
      {
        title: "Producción limitada",
        body: "Tiradas cortas, numeradas. Cuando una talla se agota, no vuelve hasta la siguiente colección."
      },
      {
        title: "Probado en montaña",
        body: "Cada prototipo acumula cientos de horas de rodaje — subidas, bajadas, lluvia y calor — antes de aprobarse. Si no aguanta, no lleva nuestro nombre."
      }
    ],
    details: [
      {
        image: "assets/img/detail-profile.jpg",
        alt: "Detalle del maillot Velodynn en perfil, con el logotipo en la manga",
        title: "Corte de competición",
        body: "Patronaje ajustado sin comprimir. Pensado para la posición aerodinámica, no para el sofá."
      },
      {
        image: "assets/img/moment-prep.jpg",
        alt: "Ciclista preparándose junto al maletero del coche antes de una ruta",
        title: "Antes de cada salida",
        body: "El ritual importa tanto como la ruta. Diseñado para el momento en que te lo pones, no solo para cuando pedaleas."
      },
      {
        image: "assets/img/motion-blur.jpg",
        alt: "Ciclista en movimiento con desenfoque de velocidad, jersey Velodynn",
        title: "Diseñado para moverse",
        body: "La tela no se nota a velocidades muy elevadas. Se adapta como una segunda piel."
      }
    ]
  };
})();
